import { TMessageSchema } from '../../types/messages';
import { TOpenedChat } from '../../types/openedChats';

export function removeDeletedMessageImages(openedChat: TOpenedChat, message: TMessageSchema) {
  const deletedImageUids = new Set((message.files?.images || []).map(image => image.uid));

  if (!deletedImageUids.size || !openedChat.images?.files?.length) {
    return openedChat.images;
  }

  return {
    ...openedChat.images,
    files: openedChat.images.files.filter(file => !deletedImageUids.has(file.uid)),
  };
}
